module.exports = __webpack_public_path__ + "media/images/area/feature/kanto/hero-4e2ef9679c2e3343df9302d6725fc3e7.jpg";